"use client";
import React from "react";
import Block from "./webflow_modules/Basic/components/Block";
import Heading from "./webflow_modules/Basic/components/Heading";
import Image from "./webflow_modules/Basic/components/Image";

export function RegionalPageHeader({
  image = "https://cdn.prod.website-files.com/656bce4e0dae8369c9788229/65e644bc47b36e79497894ed_lifestyle-city-2000x1000.jpg",
  showHero = true,
  text = "Phoenix Apartment Living",
}) {
  return showHero ? (
    <Block className={"header_lp"} tag={"header"}>
      <Block className={"padding-global"} tag={"div"}>
        <Block className={"container-small"} tag={"div"}>
          <Block className={"padding-section-large"} tag={"div"}>
            <Block className={"text-align-center"} tag={"div"}>
              <Heading className={"text-color-white"} tag={"h1"}>
                {text}
              </Heading>
            </Block>
          </Block>
        </Block>
      </Block>
      <Block className={"header69_background-image-wrapper"} tag={"div"}>
        <Block className={"image-overlay-layer"} tag={"div"} />
        <Image
          alt={""}
          className={"header69_background-image"}
          // @ts-ignore - User-defined custom attribute(s)
          fetchPriority={"high"}
          height={"auto"}
          loading={"eager"}
          src={image}
          width={"auto"}
        />
      </Block>
    </Block>
  ) : null;
}
